import { jsx as o, jsxs as c } from "react/jsx-runtime";
import { Button as r } from "../../components/Button/index.js";
import { F as i } from "../../Flex-z_b6pdCM.js";
import '../../assets/index9.css';const e = "ActionBar-module__root___dEdjn", l = {
  root: e
};
function u({ onSave: n, onCancel: t, visible: a }) {
  return a ? /* @__PURE__ */ o("div", { className: l.root, children: /* @__PURE__ */ c(i, { justify: "center", gap: "xs", children: [
    /* @__PURE__ */ o(
      r,
      {
        variant: "secondary",
        onClick: t,
        "data-plum-id": "action-bar-cancel",
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ o(
      r,
      {
        variant: "accent",
        onClick: n,
        "data-plum-id": "action-bar-save",
        children: "Save"
      }
    )
  ] }) }) : null;
}
export {
  u as ActionBar
};
